import _regeneratorRuntime from "/Users/leo/projects/ever-transit/import-export-rides-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/leo/projects/ever-transit/import-export-rides-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/Users/leo/projects/ever-transit/import-export-rides-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var AppActions = {};
export var showAppSpinner = function showAppSpinner() {
  AppActions.setLoading(true);
};
export var hideAppSpinner = function hideAppSpinner() {
  AppActions.setLoading(false);
};
export var showAppMessage = function showAppMessage(params) {
  AppActions.setMessageParams(params);
  AppActions.setIsMessageVisible(true);
};
export var updateAppActions = function updateAppActions(actions) {
  AppActions = _objectSpread(_objectSpread({}, AppActions), actions);
};
export var confirmModal = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              AppActions.setConfirmModalParams(_objectSpread(_objectSpread({}, params), {}, {
                onConfirm: function onConfirm() {
                  AppActions.setIsConfirmModalVisible(false);
                  return resolve(true);
                },
                onCancel: function onCancel() {
                  AppActions.setIsConfirmModalVisible(false);
                  return resolve(false);
                }
              }));
              AppActions.setIsConfirmModalVisible(true);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function confirmModal(_x) {
    return _ref.apply(this, arguments);
  };
}();